// HP stations should come from backend data when that endpoint exists.
export const hpStations = [];

// Station rows are titled the same way on both views.
export const getHpStationName = (station) =>
  `${station.company} - ${station.stationTitle}, ${station.address}`;

// Total segments across all stations — the overview's "units" figure for hp.
export const countHpSegments = () =>
  hpStations.reduce(
    (total, station) => total + station.segmentTitles.length,
    0,
  );
